import type { PropsWithChildren } from 'react';
import { forwardRef } from 'react';
import { Accordion as ChakraAccordion } from '@chakra-ui/react';
import type { AccordionProps as ChakraAccordionProps, SystemStyleObject } from '@chakra-ui/react';

type AccordionProps = PropsWithChildren<{
    id?: string;
    onChange?: (index: number | number[]) => void;
    defaultIndex?: number | number[];
    index?: number | number[];
    variant?: ChakraAccordionProps['variant'];
    allowMultiple?: boolean;
    sx?: SystemStyleObject;
}>;

export const Accordion = forwardRef<HTMLDivElement, AccordionProps>(
    (
        { id, children, onChange, defaultIndex = -1, index, variant, allowMultiple = false, sx },
        ref,
    ) => (
        <ChakraAccordion
            ref={ref}
            onChange={onChange}
            data-testid={id}
            width="100%"
            {...(allowMultiple ? {} : { allowToggle: true })}
            allowMultiple={allowMultiple}
            defaultIndex={defaultIndex}
            index={index}
            variant={variant}
            sx={sx}
        >
            {children}
        </ChakraAccordion>
    ),
);

Accordion.displayName = 'Accordion';
